var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-25"},[_c('FrField',{attrs:{"name":"addComment","type":"textarea","validation":"required","label":_vm.$t('common.comment')},on:{"input":function($event){return _vm.$emit('request-comment', $event);}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }